import { z } from 'zod'
import { ActivityVisibility, DifficultyLevel } from '../enums'

/**
 * Schéma de validation pour le formulaire d'activité multi-étapes
 */
export const activityFormSchema = z.object({
  establishmentId: z.string().uuid("L'établissement est requis"),
  // Étape 0 : Sélection des leçons (si nécessaire)
  lessonIds: z
    .array(z.string())
    .min(1, 'Au moins une leçon doit être sélectionnée'),
  
  // Étape 1 : Configuration de base
  title: z.string().min(1, 'Le titre est requis').max(500),
  description: z.string().optional(),
  instructions: z.string().optional(),
  typeId: z.string().uuid("Le type d'activité est requis"),
  typeCode: z.string().optional(),
  maxAttempts: z.number().optional().nullable(),

  // Étape 2 : Questions/Contenu
  content: z.record(z.string(), z.any()).optional(),
  config: z.record(z.string(), z.any()).optional(),

  // Étape 3 : Visibilité et assignements
  stateId: z.string().uuid("L'état est requis").optional(),
  visibility: z.nativeEnum(ActivityVisibility).optional(),
  state: z.enum(['ARCHIVED', 'PUBLISHED', 'DRAFT']).optional(),

  // Données optionnelles
  settings: z.record(z.string(), z.any()).optional(),
  difficulty: z.nativeEnum(DifficultyLevel).optional(),
  estimatedMinutes: z
    .union([z.number(), z.undefined()])
    .optional()
    .transform((val) =>
      val === undefined || (typeof val === 'number' && Number.isNaN(val))
        ? undefined
        : val
    )
    .pipe(z.number().min(0, 'La durée doit être positive').optional()),
  tags: z.array(z.string()).optional(),
})

export type ActivityMultiStepFormData = z.infer<typeof activityFormSchema>
